import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PersonaDto } from '../../../../../dto/tramites/persona.dto';
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { TableColumn } from '../../../../../dto/util/table-column';
import { TableAction } from '../../../../../dto/util/table-action';
import { FormField } from '../../../../../dto/util/form-field';
import { ListaValorService } from '../services/lista-valor.service';
import { FormPersonaJuridicaDto } from '../../../../forms/dto/form-persona-juridica.dto';
import { FormPersonaNaturalDto } from '../../../../forms/dto/form-persona-natural.dto';
import { Constants } from '../../../../../constants/constants';
import { TranslateService } from '@ngx-translate/core';
import { PaisDto } from '../../../../../dto/expediente/pais.dto';
import { ListasService } from '../../../../../services/listas.service';
import { TextTransformService } from '../../../../util/text-transform/text-transform.service';
import { ProteccionConsumidorService } from '../services/proteccion-consumidor.service';
import { FormComponent } from '../../../../util/form/form.component';

@Component({
  selector: 'app-datos-demandado',
  templateUrl: './datos-demandado.component.html',
  styleUrl: './datos-demandado.component.scss',
})
export class DatosDemandadoComponent implements OnInit, OnChanges {
  readonly TIPO_PERSONA_NATURAL = Constants.TYPE_OF_PERSON_NATURAL;
  readonly TIPO_PERSONA_JURIDICA = Constants.TYPE_OF_PERSON_JURIDICA;
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() anexo = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: any;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() demandadoEmit = new EventEmitter<{
    formTipoPersonaDemandado: FormGroup;
    formDemandado: FormGroup;
  }>();
  entidadId = Constants.ID_ENTIDAD_SIC;

  mostrarFormulario = true;
  formTipoPersona!: FormGroup;
  formDemandado!: FormGroup;
  demandados: PersonaDto[] = [];
  demandantes: PersonaDto[] = [];
  apoderado: PersonaDto = {};
  columnsNatural: TableColumn[] = [];
  columnsJuridic: TableColumn[] = [];
  actions: TableAction[] = [];
  dataTableNatural: PersonaDto[] = [];
  dataTableJuridic: PersonaDto[] = [];

  personaJuridica: FormPersonaJuridicaDto = {};
  personaNatural: FormPersonaNaturalDto = {};

  private prevTipo: number | null = null;
  private prevIdentificacion: string | null = null;
  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  formFieldsTipoPersona: FormField[] = [];

  formFieldsDemandadoNatural: FormField[] = [];

  formFieldsDemandadoJuridic: FormField[] = [];

  paises: PaisDto[] = [];
  // seteo inputs otro Departamento y municipio
  auxIdCountryDemandado: number[] = [];
  indexEditarDemandado: number | undefined = undefined;
  mensajeErrorDemandado: string = '';

  existePersona: boolean = false;

  buildForms() {
    this.formFieldsTipoPersona = [
      {
        name: 'tipoPersona',
        label: this.comunText['tipo-persona'],
        type: 'select',
        required: true,
        options: [
          { Id: '1', Nombre: this.comunText['persona-natural-select'] },
          { Id: '2', Nombre: this.comunText['persona-juridica-select'] },
        ],
        width: '12',
        visible: true,
        errorMessages: { required: this.comunText['tipo-persona-required'] },
      },
    ];

    this.formFieldsDemandadoNatural = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['number-document'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.maxLength(12),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
        },
      },
      {
        name: 'firstName',
        label: this.comunText['primer-nombre'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'secondName',
        label: this.comunText['segundo-nombre'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-nombre-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
        },
      },
      {
        name: 'firstLastName',
        label: this.comunText['primer-apellido'],
        type: 'text',
        required: true,
        placeholder: this.comunText['primer-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'secondLastName',
        label: this.comunText['segundo-apellido'],
        type: 'text',
        required: false,
        placeholder: this.comunText['segundo-apellido-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          pattern: this.comunText['nombre-pattern'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        options: [],
        required: true,
        width: '6',
        visible: true,
        disabled: true,
        value: 1,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamentoDemandado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-municipio'],
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];

    this.formFieldsDemandadoJuridic = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        personTypeId: '2',
        visible: true,
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['nit'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.maxLength(9)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          maxlength: this.proconText['tramite-sic-procon']['nit-maxlength'],
          pattern: this.comunText['numero-documento-pattern'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        type: 'text',
        required: true,
        placeholder: this.comunText['razon-social-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
        ],
        errorMessages: {
          pattern: this.comunText['razon-social-pattern'],
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
        },
      },
      {
        name: 'country',
        label: this.comunText['country'],
        type: 'select',
        options: [],
        required: true,
        width: '6',
        visible: true,
        disabled: true,
        value: 1,
        errorMessages: { required: this.comunText['country-required'] },
      },
      {
        name: 'departament',
        label: this.comunText['departament'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['departament-required'] },
      },
      {
        name: 'municipality',
        label: this.comunText['municipality'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['municipality-required'] },
      },
      {
        name: 'otroDepartamentoDemandado',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.comunText['departament-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-departamento'],
      },
      {
        name: 'otroMunicipioDemandado',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS),
          Validators.maxLength(30)
        ],
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-required'],
          maxlength: this.proconText['tramite-sic-procon']['campo-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined || value === null) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        },
        tooltip: this.proconText['tramite-sic-procon']['escriba-municipio'],
      },
      {
        name: 'address',
        label: this.comunText['direccion-notificacion-judicial'],
        type: 'text',
        required: true,
        placeholder:
          this.comunText['direccion-notificacion-judicial-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        maxLength: '40',
        errorMessages: {
          required: this.comunText['direccion-notificacion-judicial-required'],
          minlength:
            this.comunText['direccion-notificacion-judicial-minlength'],
          maxlength:
            this.comunText['direccion-notificacion-judicial-maxlength'],
          pattern: this.comunText['direccion-notificacion-judicial-pattern'],
        },
      },
      {
        name: 'email',
        label: this.comunText['email'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required: this.comunText['correo-required'],
          pattern: this.comunText['email-pattern'],
          maxlength: this.comunText['email-maxlength'],
        },
      },
    ];
  }

  @ViewChildren(FormComponent) personaComponentes!: QueryList<FormComponent>;

  constructor(
    private readonly fb: FormBuilder,
    private readonly alertaModalService: AlertaModalService,
    private readonly listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly listaServices: ListasService,
    private readonly proteccionConsumidorService: ProteccionConsumidorService
  ) { }

  ngOnInit() {
    this.listaServices.getCountryList().subscribe((countries: PaisDto[]) => {
      this.paises = countries;
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.formTipoPersona = this.fb.group({
      tipoPersona: ['', Validators.required],
    });

    this.formDemandado = this.fb.group({
      firstName: ['', Validators.required],
    });

    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
      this.buildForms();
      this.iniciarColumnas();
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
      this.buildForms();
      this.iniciarColumnas();
    });

    this.demandantes = JSON.parse(sessionStorage.getItem('demandantes')!);
    this.apoderado = JSON.parse(sessionStorage.getItem('apoderado')!);
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic'].currentValue;

    //Si el tramite cambia, se seta toda la informacion del mismo
    if (tramite !== undefined) {
      if (tramite?.demandado !== undefined) {
        for (const demandado of tramite.demandado) {
          if (
            !this.demandados.some(
              dem =>
                dem.idTipoIdentificacion === demandado.idTipoIdentificacion &&
                dem.identificacion === demandado.identificacion
            )
          ) {
            this.demandados.push(demandado);
            sessionStorage.setItem('demandados', JSON.stringify(this.demandados));
          }
        }

        this.dataTableNatural = this.demandados.filter(
          item => item.idTipoPersona === 1
        );
        this.dataTableJuridic = this.demandados.filter(
          item => item.idTipoPersona === 2
        );

        this.iniciarColumnas();
        this.reiniciarFormularios();
      }
    }
  }

  private iniciarColumnas() {
    this.columnsNatural = [
      {
        field: 'primerNombre',
        title: this.comunText['primer-nombre'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'primerApellido',
        title: this.comunText['primer-apellido'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.columnsJuridic = [
      {
        field: 'razonSocial',
        title: this.comunText['razon-social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.comunText['numero-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];

    this.actions = [
      {
        type: 'button',
        title: '',
        icon: 'pencil-square-o',
        idAccion: '2',
      },
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }

  validarFormularioTipoPersona(formGroup: FormGroup) {
    if (formGroup?.valid) {
      this.formTipoPersona = formGroup;
    }
  }

  validarFormularioDemandado($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    const formGroup = $event.form;

    // if (formGroup.valid) {
    this.formDemandado = formGroup;
    // }
    const tipo = formGroup?.value['typeOfDocument'];
    const identificacion = formGroup?.value['numberOfDocument'];

    // Si los valores han cambiado, proceder
    const tipoHaCambiado = tipo !== this.prevTipo;
    const identificacionHaCambiado = identificacion !== this.prevIdentificacion;

    if (
      tipo &&
      identificacion &&
      (tipoHaCambiado || identificacionHaCambiado)
    ) {
      this.prevTipo = tipo;
      this.prevIdentificacion = identificacion;

      /*this.listaValorService.persona(tipo, identificacion).subscribe(data => {
        if (data) {
          // this.mostrarFormulario = false;
          this.setDatosUsuario(data);
          this.alertaModalService.exito(
            this.alertaText['sic-procon-alertas']['atencion'],
            this.alertaText['sic-procon-alertas']['datos-autocompletados']
          );
        } else {
          formGroup.patchValue({
            firstName: '',
            secondName: '',
            firstLastName: '',
            secondLastName: '',
            address: '',
            phone: '',
            country: '',
            departament: '',
            municipality: '',
            email: '',
            razonSocial: '',
            representativeFirstName: '',
            representativeSecondName: '',
            representativFirstLastName: '',
            representativeSecondLastName: '',
          });
        }
      });*/
    }

    this.demandadoEmit.emit({
      formTipoPersonaDemandado: this.formTipoPersona,
      formDemandado: this.formDemandado,
    });
  }

  onChangeValidarFormulario($event: {
    controlName?: string;
    controlValue: unknown;
    form: FormGroup;
  }) {
    let formGroup = $event.form;
    let idTipoDocumento: number = +formGroup?.get('typeOfDocument')?.value;
    let identificacion: number = +formGroup?.get('numberOfDocument')?.value;
    const numeroDocumentoDemandadoN = this.formFieldsDemandadoNatural.find(
      field => field.name == 'numberOfDocument'
    );
    const numeroDocumentoDemandadoJ = this.formFieldsDemandadoJuridic.find(
      field => field.name == 'numberOfDocument'
    );
    if ($event.controlName == 'typeOfDocument') {
      formGroup.get('numberOfDocument')?.setValue('');
      if (idTipoDocumento !== null && identificacion !== null) {
        if (
          idTipoDocumento == 1 ||
          idTipoDocumento == 2 ||
          idTipoDocumento == 5
        ) {
          if (numeroDocumentoDemandadoN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(12),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandadoN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength'];
            numeroDocumentoDemandadoN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength'];
            numeroDocumentoDemandadoN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        } else if (idTipoDocumento == 4) {
          if (numeroDocumentoDemandadoN != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.minLength(4),
                Validators.maxLength(8),
                Validators.pattern(
                  Constants.REGEX_ALFANUMERICO_VALIDATION_SIN_ESPACIO
                ),
              ]);
            numeroDocumentoDemandadoN.errorMessages!['minlength'] =
              this.comunText['numero-documento-minlength-ce'];
            numeroDocumentoDemandadoN.errorMessages!['maxlength'] =
              this.comunText['numero-documento-maxlength-ce'];
            numeroDocumentoDemandadoN.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern-ce'];
          }
        } else if (idTipoDocumento == 3) {
          if (numeroDocumentoDemandadoJ != undefined) {
            formGroup
              .get('numberOfDocument')
              ?.setValidators([
                Validators.required,
                Validators.maxLength(9),
                Validators.pattern(/^\d+$/),
              ]);
            numeroDocumentoDemandadoJ.errorMessages!['maxlength'] =
              this.proconText['tramite-sic-procon']['nit-maxlength'];
            numeroDocumentoDemandadoJ.errorMessages!['pattern'] =
              this.comunText['numero-documento-pattern'];
          }
        }
        formGroup.get('numberOfDocument')?.updateValueAndValidity();
      }
    }
    if ($event.controlName === 'country') {
      const idPais = formGroup.get('country')?.value;
      const idColombia = this.paises.find(
        item => item.Codigo === Constants.CODIGO_COLOMBIA
      )?.Id;
      if (idPais === idColombia) {
        formGroup?.controls['otroDepartamentoDemandado']?.removeValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandado']?.removeValidators(
          Validators.required
        );
        formGroup.get('otroDepartamentoDemandado')?.reset();
        formGroup.get('otroMunicipioDemandado')?.reset();
        formGroup.get('otroDepartamentoDemandado')?.updateValueAndValidity();
        formGroup.get('otroMunicipioDemandado')?.updateValueAndValidity();
      } else if (idPais !== null) {
        let clearInputs: boolean = false;
        if (formGroup?.controls['country'].value) {
          this.auxIdCountryDemandado.push(formGroup?.controls['country'].value);
          if (this.auxIdCountryDemandado.length > 1) {
            clearInputs =
              formGroup?.controls['country'].value !=
              this.auxIdCountryDemandado[this.auxIdCountryDemandado.length - 2];
          }
        }
        if (clearInputs) {
          formGroup?.controls['otroDepartamentoDemandado'].setValue('');
          formGroup?.controls['otroMunicipioDemandado'].setValue('');
        }
        formGroup?.controls['otroDepartamentoDemandado']?.addValidators(
          Validators.required
        );
        formGroup?.controls['otroMunicipioDemandado']?.addValidators(
          Validators.required
        );
        formGroup.get('otroDepartamentoDemandado')?.updateValueAndValidity();
        formGroup.get('otroMunicipioDemandado')?.updateValueAndValidity();
      }
    }
  }

  personaDemandada(event: FormGroup) {
    this.demandantes = JSON.parse(sessionStorage.getItem('demandantes')!);
    this.apoderado = JSON.parse(sessionStorage.getItem('apoderado')!);
    if (event) {
      let formValue = event.value;
      const tipo = formValue['typeOfDocument'];
      const identificacion = formValue['numberOfDocument'];
      if (tipo && identificacion) {
        const isEmptyDemandado = this.demandados.some(
          item =>
            item.idTipoIdentificacion == tipo &&
            item.identificacion == identificacion
        );
        const isEmptyDemandante = this.searchInDemandantes(tipo, identificacion, false);
        const isEmptyApoderado = this.searchInApoderado(tipo, identificacion, false);

        // Si alguno EXISTE → limpiar
        if (isEmptyDemandado ||
          !isEmptyDemandante ||
          !isEmptyApoderado) {
          this.existePersona = true;
        } else {
          this.existePersona = false;
        }
      }
    }
  }

  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    let cargaronNuevosArchivos = JSON.parse(sessionStorage.getItem(Constants.ARCHIVOS_SIC_PROCON_PASO_UNO)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
      if (this.tramiteSic) {
        if (this.tramiteSic.apoderado?.id!) {
          if (this.tramiteSic.anexos?.length == 0) {
            this.anexo.emit({
              tramite: this.tramiteSic,
              formValid: true,
              event: {},
            });
          } else if (cargaronNuevosArchivos) {
            this.anexo.emit({
              tramite: this.tramiteSic,
              formValid: true,
              event: {},
            });
          }
        }
      }
    }
  }

  consultarTramitePorID(event: any, id: number) {
    this.proteccionConsumidorService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteSicProteccionConsumidorDto) => {

      });
  }

  validarPestania(): boolean {
    if (this.demandados.length > 0) {
      const indiceConError = this.demandados.findIndex(
        (demandado) => !this.validarCamposDemandado(demandado)
      );
      if (indiceConError !== -1) {
        this.mensajeErrorDemandado = this.comunText['valide-datos'];
        return false;
      } else {
        this.mensajeErrorDemandado = '';
        return true;
      }
    } else {
      return false;
    }
  }

  validarCamposDemandado(demandado: PersonaDto): boolean {
    const esNatural = demandado.idTipoPersona === Constants.TIPO_PERSONA.NATURAL;
    // Validaciones comunes
    if (!demandado.idTipoIdentificacion) {
      return false;
    }

    if (!demandado.identificacion) {
      return false;
    }
    if (!demandado.direccionPersona?.[0]?.direccionNotificacion) {
      return false;
    }

    if (!demandado.correoElectronico ||
      !(new RegExp(Constants.REGEX_CORREO_ELECTRONICO)).test(demandado.correoElectronico)) {
      return false;
    }

    if (!demandado.municipio?.id) {
      return false;
    }

    //  Validaciones específicas
    if (esNatural) {
      if (!demandado.primerNombre ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandado.primerNombre)
      ) {
        return false;
      }

      if (!demandado.primerApellido ||
        !(new RegExp(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT)).test(demandado.primerApellido)) {
        return false;
      }
    } else {
      if (!demandado.razonSocial ||
        !(new RegExp(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL)).test(demandado.razonSocial)) {
        return false;
      }
    }
    return true;
  }


  cancelarEditarDemandado() {
    this.indexEditarDemandado = undefined;
    this.formDemandado.reset();
    this.formTipoPersona.reset();
    this.formFieldsDemandadoJuridic = this.formFieldsDemandadoJuridic.map(
      field => {
        if (field.name !== 'country') {
          field.value = undefined;
          field.disabled = false;
        }
        return field;
      }
    );

    this.formFieldsDemandadoNatural = this.formFieldsDemandadoNatural.map(
      field => {
        if (field.name !== 'country') {
          field.value = undefined;
          field.disabled = false;
        }
        return field;
      }
    );
  }

  agregarDemandado(index: number | undefined = undefined) {
    const { tipoPersona } = this.formTipoPersona.value;
    const {
      typeOfDocument,
      numberOfDocument,
      razonSocial,
      address,
      phone,
      municipality,
      email,
      firstName,
      secondName,
      firstLastName,
      secondLastName,
      otroDepartamentoDemandado,
      otroMunicipioDemandado,
    } = this.formDemandado.value;

    const isPersonaNatural = tipoPersona == Constants.TIPO_PERSONA.NATURAL;

    const demandado: PersonaDto = {
      idTipoPersona: Number(tipoPersona),
      idTipoIdentificacion:
        typeOfDocument ??
        this.personaNatural.typeOfDocument ??
        this.personaJuridica.typeOfDocument,
      identificacion:
        numberOfDocument ??
        this.personaNatural.numberOfDocument ??
        this.personaJuridica.numberOfDocument,
      razonSocial: !isPersonaNatural
        ? (razonSocial ?? this.personaJuridica.razonSocial)
        : undefined,
      direccionPersona: [
        {
          direccionNotificacion:
            address ??
            this.personaNatural.address ??
            this.personaJuridica.address,
        },
      ],
      telefonoPrincipal: phone,
      municipio: {
        id:
          municipality ??
          this.personaNatural.municipality ??
          this.personaJuridica.municipality,
        idDepartamento: Number(this.formDemandado.value['departament']) ?? undefined,
        idPais: Constants.ID_COLOMBIA,
      },
      departamentoExtranjero: otroDepartamentoDemandado,
      ciudadExtranjero: otroMunicipioDemandado,
      correoElectronico:
        email ?? this.personaNatural.email ?? this.personaJuridica.email,
      primerNombre: isPersonaNatural
        ? (firstName ?? this.personaNatural.firstName)
        : undefined,
      segundoNombre: isPersonaNatural
        ? (secondName ?? this.personaNatural.secondName)
        : undefined,
      primerApellido: isPersonaNatural
        ? (firstLastName ?? this.personaNatural.firstLastName)
        : undefined,
      segundoApellido: isPersonaNatural
        ? (secondLastName ?? this.personaNatural.secondLastName)
        : undefined,
    };
    let existe;
    if (index !== undefined) {
      existe = this.demandados.some(
        (item, i) =>
          index !== i &&
          item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
          item.identificacion === demandado.identificacion
      );
    } else {
      existe = this.demandados.some(
        item =>
          item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
          item.identificacion === demandado.identificacion
      );
    }
    this.demandantes = JSON.parse(sessionStorage.getItem('demandantes')!);
    this.apoderado = JSON.parse(sessionStorage.getItem('apoderado')!);
    const isEmptyDemandante: boolean = this.searchInDemandantes(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!,
      true
    );
    const isEmptyApoderado: boolean = this.searchInApoderado(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!,
      true
    );
    if (isEmptyDemandante && isEmptyApoderado) {
      if (existe) {
        this.existePersona = existe;
        this.alertaModalService.advertencia(
          this.alertaText['error'],
          this.alertaText['demandado-ya-agregado']
        );
      } else {
        if (index !== undefined) {
          this.demandados[index] = demandado;
        } else {
          this.demandados.push(demandado);
        }
        this.dataTableNatural = this.demandados.filter(
          item => item.idTipoPersona === 1
        );
        this.dataTableJuridic = this.demandados.filter(
          item => item.idTipoPersona === 2
        );
        this.iniciarColumnas();
        this.reiniciarFormularios();
        this.alertaModalService.exito(
          this.alertaText['agregado'],
          this.alertaText['demandado-agregado']
        );
        sessionStorage.setItem('demandados', JSON.stringify(this.demandados));
        this.indexEditarDemandado = undefined;
      }
    }
    this.auxIdCountryDemandado = [];
  }

  onClickSiguiente(event: Event) {
    const esValido = this.validarPestania();

    if (!esValido) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // Si está todo bien, continuar flujo normal
    this.pasarAReclamoDirecto(event, false);
  }

  pasarAReclamoDirecto(e: Event, guardarSinEnviar: boolean) {
    let paso = JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(3));
    }
    if (this.formTipoPersona.valid) {
      if (!guardarSinEnviar) {
        if (this.formDemandado.valid) {
          this.agregarDemandado(this.indexEditarDemandado)
        }
      } else {
        this.agregarDemandado(this.indexEditarDemandado)
      }
    }
    const tramite: TramiteSicProteccionConsumidorDto = {
      demandado: this.demandados,
    };

    const formValid = this.demandados.length > 0;

    if (!guardarSinEnviar) {
      this.continuar.emit({
        tramite: tramite,
        formValid,
        event: e,
      });
    } else {
      this.guardarSinEnviar.emit({
        tramite: tramite,
        formValid,
        event: e,
      });
    }
  }

  accionesDemandado(event: any) {
    const persona = event.item as PersonaDto;
    if (event.idAccion == '2') { // editar
      this.indexEditarDemandado = this.demandados.findIndex(
        (d) =>
          d.idTipoIdentificacion == persona.idTipoIdentificacion &&
          d.identificacion == persona.identificacion
      );
      this.setearDatosDemandado(persona);
    } else if (event.idAccion == '1') { // eliminar
      this.alertaModalService.confirmacion(
        this.alertaText['sic-procon-alertas']['eliminar-registro'],
        '',
        () => {
          const persona = event.item as PersonaDto;
          this.demandados = this.demandados.filter(item => item !== persona);

          this.dataTableNatural = this.demandados.filter(
            item => item.idTipoPersona === 1
          );
          this.dataTableJuridic = this.demandados.filter(
            item => item.idTipoPersona === 2
          );

          this.prevTipo = null;
          this.prevIdentificacion = null;
          this.mostrarFormulario = true;
          sessionStorage.setItem('demandados', JSON.stringify(this.demandados));
          this.iniciarColumnas();
        },
        () => { }
      );
    }
  }

  setearDatosDemandado(persona: PersonaDto) {
    this.formTipoPersona.patchValue({
      tipoPersona: `${persona.idTipoPersona ?? '1'}`,
    });
    this.formFieldsTipoPersona = this.formFieldsTipoPersona.map(field => {
      switch (field.name) {
        case 'tipoPersona':
          field.value = persona.idTipoPersona?.toString() ?? '1';
          break;
      }
      return field;
    });
    if (persona.idTipoPersona === Constants.TIPO_PERSONA.NATURAL) {
      setTimeout(() => {
        this.formFieldsDemandadoNatural = this.formFieldsDemandadoNatural.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'firstName':
              field.value = persona.primerNombre;
              break;
            case 'secondName':
              field.value = persona.segundoNombre;
              break;
            case 'firstLastName':
              field.value = persona.primerApellido;
              break;
            case 'secondLastName':
              field.value = persona.segundoApellido;
              break;
            case 'address':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              field.disabled = true;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandado':
              field.value = persona.otroDepartamento;
              break;
            case 'otroMunicipioDemandado':
              field.value = persona.otroMunicipio;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
          }
          return field;
        });
      }, 300);
    }
    else {
      setTimeout(() => {
        this.formFieldsDemandadoJuridic = this.formFieldsDemandadoJuridic.map(field => {
          switch (field.name) {
            case 'typeOfDocument':
              field.value = persona.idTipoIdentificacion;
              break;
            case 'numberOfDocument':
              field.value = persona.identificacion;
              break;
            case 'razonSocial':
              field.value = persona.razonSocial;
              break;
            case 'address':
              field.value = persona.direccionPersona?.[0]?.direccionNotificacion;
              break;
            case 'country':
              field.value = persona.municipio?.idPais;
              field.disabled = true;
              break;
            case 'departament':
              field.value = persona.municipio?.idDepartamento;
              break;
            case 'municipality':
              field.value = persona.municipio?.id;
              break;
            case 'otroDepartamentoDemandado':
              field.value = persona.otroDepartamento;
              break;
            case 'otroMunicipioDemandado':
              field.value = persona.otroMunicipio;
              break;
            case 'email':
              field.value = persona.correoElectronico;
              break;
          }
          return field;
        });
      }, 300);
    }
  }




  reiniciarFormularios() {
    if (!this.existePersona) {
      this.mostrarFormulario = false;
      this.prevTipo = null;
      this.prevIdentificacion = null;

      setTimeout(() => {
        this.mostrarFormulario = true;
        this.formDemandado.reset();
        this.formTipoPersona.reset();
        this.personaJuridica = {};
        this.personaNatural = {};

        this.formFieldsDemandadoJuridic = this.formFieldsDemandadoJuridic.map(
          field => {
            if (field.name !== 'country') {
              field.value = undefined;
              field.disabled = false;
            }
            return field;
          }
        );

        this.formFieldsDemandadoNatural = this.formFieldsDemandadoNatural.map(
          field => {
            if (field.name !== 'country') {
              field.value = undefined;
              field.disabled = false;
            }
            return field;
          }
        );
      }, 1);
    } else {
      this.formDemandado.get('numberOfDocument')?.setErrors({ incorrect: true });
    }
  }

  isButtonDisabled(): boolean {
    return this.formDemandado.invalid;
  }

  searchInApoderado(
    idTipoDocumento: number,
    identificacion: number,
    showMessage: boolean
  ): boolean {
    if (this.apoderado) {
      if (
        this.apoderado.idTipoIdentificacion == idTipoDocumento &&
        +this.apoderado.identificacion! == identificacion
      ) {
        if (showMessage) {
          this.alertaModalService.advertencia(
            this.alertaText['tipo-numero-documento-existe-apoderado']
          );
        }
        return false;
      }
    }
    return true;
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number,
    showMessage: boolean
  ): boolean {
    let isEmpty = true;
    if (this.demandantes) {
      this.demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion == idTipoDocumento &&
          +elemento.identificacion! == identificacion
        ) {
          if (showMessage) {
            this.alertaModalService.advertencia(
              this.alertaText['tipo-numero-documento-existe-demandante']
            );
          }
          isEmpty = false;
        }
      });
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }
}
